<template>
      <div fluid fill-height>
            <v-expand-x-transition>
                  <landing-toolbar />
            </v-expand-x-transition>
            <v-container style="min-width: 100% !important;padding-top: 0px;">
                  <Groups />
            </v-container>
      </div>
</template>
<script>

import LandingToolbar from "../../components/LandingToolbar/LandingToolbar.vue";
import Groups from '../../components/Definiciones/Grupos/Groups.vue';

export default {
      components: { LandingToolbar, Groups },
};
</script>
        